let VCA = VCA || {};

VCA.GuestAccountSetUp = (function ($) {
    let ui = {};
    let petCountIdxNum = 0;
    let haveOneNumValid = false;
    let haveOneUppercaseValid = false;
    let haveOneLowercaseValid = false;
    let haveOneSpecialCharValid = false;
    let have8MinCharValid = false;
    let generalPwFinalValue = '';
    let confirmPwFinalValue = '';

    function cacheUI() {
        //Sections
        ui.$sections = $('section.js-account-step');
        ui.$ProfileStep = $('section[data-step="profile"]');
        ui.$PrimaryAddressStep = $('section[data-step="primary-address"]');
        ui.$PetsInfoStep = $('section[data-step="pets-info"]');
        ui.$SetPasswordStep = $('section[data-step="set-password"]');

        //Step1 - Profile
        ui.$Step1ContinueBtn = $('#GuestAcctProfileContinueBtn');
        ui.$Step1Email = $('#GuestAccountEmail');
        ui.$Step1FirstName = $('#GuestAccountFName');
        ui.$Step1LastName = $('#GuestAccountLName');
        ui.$Step1PhoneNum = $('#GuestAccountPhoneNum');

        //Step2 - Primary Address
        ui.$Step2ContinueBtn = $('#GuestAcctPrimaryAddressContinueBtn');
        ui.$Step2Address1 = $('#GuestAccountAddress1');
        ui.$Step2Address2 = $('#GuestAccountAddress2');
        ui.$Step2City = $('#GuestAccountCity');
        ui.$Step2State = $('#GuestAccountState');
        ui.$Step2ZipCode = $('#GuestAccountZipCode');
        ui.$Step2Country = $('#GuestAccountCountry');
        ui.$IsCanadaHiddenInput = $('#IsCanada');

        //Step 3 - Pet's Info
        ui.$Step3ContinueBtn = $('#GuestAcctPetsInfoContinueBtn');
        ui.$SelectPet = $('button.pet-selection');
        ui.$AddPetBtn = $('button.add-another-pet');

        //Step4 - Set Password
        ui.$Step4ContinueBtn = $('#GuestAcctPasswordContinueBtn');
        ui.$PasswordInput = $('.account-password-input');
        ui.$PasswordEyeIcon = $('.password-eye-icon');
        ui.$Step4GuestAcctErrMsg = $('#GuestAccountErrorMsg');

        //Back Btn
        ui.$BackBtn = $('.account-setup__back-btn');
        ui.$Step4BackBtn = $('section[data-step="set-password"]').find('.account-setup__back-btn');

        //Other
        ui.$InputEl = $('input');
        ui.$Loader = $('.account-setup__loading-gif');
    }

    function bindEvents() {
        ui.$Step1ContinueBtn.on('click', validateProfileStep1);
        ui.$Step2ContinueBtn.on('click', validatePrimaryAddressStep2);
        ui.$Step3ContinueBtn.on('click', addPetsInfoStep3);
        ui.$Step4ContinueBtn.on('click', sendDataLayer);
        ui.$Step4ContinueBtn.on('click', showLoader);

        ui.$Step1PhoneNum.on('keydown', detectKeydown);
        ui.$SelectPet.on('click', hideSelectPetErrMsg);
        ui.$AddPetBtn.on('click', addPet);
        ui.$PasswordEyeIcon.on('click', togglePassword);
        ui.$PasswordInput.on('focus', showTooltipModal);
        ui.$PasswordInput.on('blur', hideTooltipModal);
        ui.$PasswordInput.on('keyup paste', validatePassword);
        ui.$InputEl.on('keyup paste', hideErrorMessages);
        ui.$BackBtn.on('click', backBtnClick);
        ui.$Step4BackBtn.on('click', hideStep4ErrMsg);
    }

    function init() {
        if ($('.guest-account-setup').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        checkIfErrorMsgIsPresent();
        selectPet();
        deletePet();
        initSelectedPet();
    }

    function hideErrorMessages(e) {
        const el = $(e.currentTarget);
        el.removeClass('error');
        el.closest('.form-label-group').find('.input-error-text').hide();
    }

    function checkIfErrorMsgIsPresent() {
        let errorMsg = ui.$Step4GuestAcctErrMsg.html().trim();

        if (errorMsg.length == 0) {
            let targetValue = 'profile';
            updateProgressBar(targetValue);
            ui.$Step4GuestAcctErrMsg.hide();
            ui.$ProfileStep.show();
        } else {
            let targetValue = ui.$Step3ContinueBtn.data('target');
            ui.$sections.hide();
            updateProgressBar(targetValue);
            ui.$Step4GuestAcctErrMsg.show();
            ui.$SetPasswordStep.show();
        }
    }

    function detectKeydown(e) {
        if (e.which === 38 || e.which === 40) {
            e.preventDefault();
        }
    }

    function validateProfileStep1() {
        let email = ui.$Step1Email.val();
        let firstName = ui.$Step1FirstName.val();
        let lastName = ui.$Step1LastName.val();
        let phoneNum = ui.$Step1PhoneNum.val();
        let emailValid = false;
        let firstNameValid = false;
        let lastNameValid = false;
        let phoneNumValid = false;

        ui.$Step1Email.attr('value',email);
        ui.$Step1FirstName.attr('value', firstName);
        ui.$Step1LastName.attr('value', lastName);
        ui.$Step1PhoneNum.attr('value', phoneNum);

        //Validate email
        let emailRegex = /\S+@\S+\.\S+/;
        let validateEmail = emailRegex.test(email);

        if (email.trim() == '') {
            ui.$Step1Email.addClass('error');
            ui.$Step1Email.parent().find('.error-msg.required').show();
            ui.$Step1Email.parent().find('.input-error-text').show();
        } else {
            ui.$Step1Email.parent().find('.error-msg').hide();

            if (validateEmail) {
                ui.$Step1Email.removeClass('error');
                ui.$Step1Email.parent().find('.input-error-text').hide();
                emailValid = true;
            } else {
                ui.$Step1Email.addClass('error');
                ui.$Step1Email.parent().find('span.error-msg.invalid').show();
                ui.$Step1Email.parent().find('.input-error-text').show();
            }
        }
        
        //Validate first name and last name
        if (firstName.trim() == '') {
            ui.$Step1FirstName.addClass('error');
            ui.$Step1FirstName.parent().find('.input-error-text').show();
        } else {
            ui.$Step1FirstName.removeClass('error');
            ui.$Step1FirstName.parent().find('.input-error-text').hide();
            firstNameValid = true;
        }

        if (lastName.trim() == '') {
            ui.$Step1LastName.addClass('error');
            ui.$Step1LastName.parent().find('.input-error-text').show();
        } else {
            ui.$Step1LastName.removeClass('error');
            ui.$Step1LastName.parent().find('.input-error-text').hide();
            lastNameValid = true;
        }

        //valid Phone Number
        if (phoneNum == '') {
            ui.$Step1PhoneNum.addClass('error');
            ui.$Step1PhoneNum.parent().find('.error-msg.required').show();
            ui.$Step1PhoneNum.parent().find('.input-error-text').show();
        } else {
            ui.$Step1PhoneNum.parent().find('.error-msg').hide();

            if (phoneNum.length == 10) {
                ui.$Step1PhoneNum.removeClass('error');
                ui.$Step1PhoneNum.parent().find('.input-error-text').hide();
                phoneNumValid = true;
            } else {
                ui.$Step1PhoneNum.addClass('error');
                ui.$Step1PhoneNum.parent().find('span.error-msg.invalid').show();
                ui.$Step1PhoneNum.parent().find('.input-error-text').show();
            }
        }

        //If all input fields are valid --> Move on to STEP 2
        if (emailValid && firstNameValid && lastNameValid && phoneNumValid) {
            let targetValue = ui.$Step1ContinueBtn.data('target');

            ui.$sections.hide();
            updateProgressBar(targetValue);
            ui.$PrimaryAddressStep.show();
        }
    }

    function validatePrimaryAddressStep2() {
        let address1 = ui.$Step2Address1.val();
        let address2 = ui.$Step2Address2.val();
        let city = ui.$Step2City.val();
        let state = ui.$Step2State.val();
        let zipCode = ui.$Step2ZipCode.val();
        let country = ui.$Step2Country.val();

        let address1Valid = false;
        let cityValid = false;
        let stateValid = false;
        let zipCodeValid = false;
        let countryValid = false;

        ui.$Step2Address1.attr('value',address1);
        ui.$Step2Address2.attr('value', address2);
        ui.$Step2City.attr('value', city);
        ui.$Step2State.attr('value', state);
        ui.$Step2ZipCode.attr('value', zipCode);
        ui.$Step2Country.attr('value', country);

        //Country - Canada 
        if (country.toLowerCase() == 'canada') {
            ui.$IsCanadaHiddenInput.val('true');
        } else {
            ui.$IsCanadaHiddenInput.val('false');
        }

        //Validate Address 1
        if (address1.trim() == '') {
            ui.$Step2Address1.addClass('error');
            ui.$Step2Address1.parent().find('.input-error-text').show();
        } else {
            ui.$Step2Address1.removeClass('error');
            ui.$Step2Address1.parent().find('.input-error-text').hide();
            address1Valid = true;
        }

        //Validate City
        if (city.trim() == '') {
            ui.$Step2City.addClass('error');
            ui.$Step2City.parent().find('.input-error-text').show();
        } else {
            ui.$Step2City.removeClass('error');
            ui.$Step2City.parent().find('.input-error-text').hide();
            cityValid = true;
        }

        //Validate State
        if (state && state !== 'State*') {
            ui.$Step2State.removeClass('error');
            ui.$Step2State.parent().find('.input-error-text').hide();
            stateValid = true;
        } else {
            ui.$Step2State.addClass('error');
            ui.$Step2State.parent().find('.input-error-text').show();
        }


        //Validate ZipCode
        let canadaZipCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

        if (isCanada) { //Use case for Canada zipcode
            if (zipCode.trim() == '') {
                ui.$Step2ZipCode.addClass('error');
                ui.$Step2ZipCode.parent().find('.error-msg.required').show();
                ui.$Step2ZipCode.parent().find('.input-error-text').show();
            } else {
                let isValidCanadaZipCode = canadaZipCodeRegex.test(zipCode);
                ui.$Step2ZipCode.parent().find('.error-msg').hide();

                if (isValidCanadaZipCode) {
                    ui.$Step2ZipCode.removeClass('error');
                    ui.$Step2ZipCode.parent().find('.input-error-text').hide();
                    zipCodeValid = true;
                } else {
                    ui.$Step2ZipCode.addClass('error');
                    ui.$Step2ZipCode.parent().find('.error-msg.invalid').show();
                    ui.$Step2ZipCode.parent().find('.input-error-text').show();
                }
            }
        } else { // CANADA COUNTRY NOT SELECTED
            if (isNaN(zipCode) == false && zipCode.length == 5) {
                ui.$Step2ZipCode.removeClass('error');
                ui.$Step2ZipCode.parent().find('.input-error-text').hide();
                zipCodeValid = true;
            } else if (zipCode.trim() == '') {
                ui.$Step2ZipCode.addClass('error');
                ui.$Step2ZipCode.parent().find('.error-msg.required').show();
                ui.$Step2ZipCode.parent().find('.input-error-text').show();
            } else {
                ui.$Step2ZipCode.addClass('error');
                ui.$Step2ZipCode.parent().find('.error-msg.invalid').show();
                ui.$Step2ZipCode.parent().find('.input-error-text').show();
            }
        }


        //Validate Country
        if (country && country !== 'Country*') {
            ui.$Step2Country.removeClass('error');
            ui.$Step2Country.parent().find('.input-error-text').hide();
            countryValid = true;
        } else {
            ui.$Step2Country.addClass('error');
            ui.$Step2Country.parent().find('.input-error-text').show();
        }

        //If all input fields are valid --> Move on to STEP 3
        if (address1Valid && cityValid && stateValid && zipCodeValid && countryValid) {
            let targetValue = ui.$Step2ContinueBtn.data('target');

            ui.$sections.hide();
            updateProgressBar(targetValue);
            ui.$PetsInfoStep.show();
        }

    }

    function addPetsInfoStep3() {
        let petList = $('.pet-info__list');
        let petInfoItem = $('.pet-info__pet');
        let petNameInputValid = false;
        let petTypeValid = false;

        //Validate input text field && if user selected pet type
        petList.find(petInfoItem).each((index,petItem) => {
            let petNameInput = $(`#GuestAccountPetName-${index}`);
            let petNameValue = petNameInput.val();        
            petNameInput.attr('value',petNameValue);

            if (petNameValue.trim() == '') {
                petNameInput.addClass('error');
                petNameInput.parent().find('.input-error-text').show();
            } else {
                petNameInput.removeClass('error');
                petNameInput.parent().find('.input-error-text').hide();
            }

            //Validate if user selected dog or cat
            let petTypeBtnsWrapper = $(petItem).find('.pet-info__pet-option')[0];
            let petTypeSelected = $(petTypeBtnsWrapper).children('div').children().children('button.pet-selection.active').length != 0;
            let errorMsgContainer = $(petTypeBtnsWrapper).find('.pet-error-text');

            if (!petTypeSelected) {
                $(petTypeBtnsWrapper).addClass('error');
                $(errorMsgContainer).show();
            } else {
                $(petTypeBtnsWrapper).removeClass('error');
                $(errorMsgContainer).hide();
            }

        });

        //Validate if all input text fields have been filled out && if pet types have been selected
        let petNameInputFieldsErrors = $(petInfoItem).children('.form-label-group').children('.pet-input.error').length != 0;
        petNameInputValid = petNameInputFieldsErrors ? false : true ;

        let petTypeOptionsErrors = $(petInfoItem).children('.pet-info__pet-option.error').length != 0;
        petTypeValid = petTypeOptionsErrors ? false : true ;


        //If all input fields && pet types are valid --> Move on to STEP 4
        if (petNameInputValid && petTypeValid) {
            let targetValue = ui.$Step3ContinueBtn.data('target');

            ui.$sections.hide();
            updateProgressBar(targetValue);
            ui.$SetPasswordStep.show();
        }
    }

    function initSelectedPet() {
        ui.$SelectPet.each((x,btn) => {
            if ($(btn).data('selected') == true) {
                let speciesId = $(btn).data('speciesid');
                $(btn).addClass('active');
                $(btn).parents('.pet-info__pet').find('.pet-speciesid-input').val(speciesId);
            }
        }); 
    }

    function selectPet() {
        $('body').on('click', 'button.pet-selection', function (e) {

            let el = e.currentTarget;
            let isActive = $(el).hasClass('active');
            let selectedPetSpeciesId = '';
        
            if (!isActive) {
                $(el).parent().find('.pet-selection').each((x,y) => {
                    $(y).removeClass('active');
                    selectedPetSpeciesId = '';
                });
                $(el).addClass('active');
                selectedPetSpeciesId = $(el).data('speciesid');
                
            } else {
                $(el).removeClass('active');
                selectedPetSpeciesId = '';
            }
    
            //Update speciesId value to hidden input
            let inputGroup = $(el).closest('.pet-info__pet').find('.form-label-group');
            $(inputGroup).find('.pet-speciesid-input').val(selectedPetSpeciesId);
        });
    }

    function hideSelectPetErrMsg(e) {
        let btn = $(e.currentTarget);
        $(btn).parents('.pet-info__pet-option').find('.pet-error-text').hide();
    }

    function deletePet() {
        $('body').on('click', 'button.pet-info__delete-btn', function (e) {
            let deleteBtn = e.currentTarget;
            let petItemContainer = $(deleteBtn).closest('.pet-info__pet')[0];
            $(petItemContainer).remove();
            updateIdxPosition();
        });
    }

    function addPet() {
        petCountIdxNum++;

        let addPetContainer = $(`
            <div class="pet-info__pet">
                <div class="form-label-group">
                    <input id="GuestAccountPetName-${petCountIdxNum}" class="pet-input" name="Form.Pets[${petCountIdxNum}].PetName" type="text" placeholder="Pet Name" value="">
                    <label for="GuestAccountPetName-${petCountIdxNum}">Pet Name</label>
                    <input id="Form_Pets_${petCountIdxNum}__SpeciesId" class="pet-speciesid-input" name="Form.Pets[${petCountIdxNum}].SpeciesId" type="hidden" value="">
                    <div class="input-error-text" style="display: none;">
                        <i class="fas fa-exclamation-circle error-icon"></i>
                        <span class="error-msg">Pet Name Required</span>
                    </div>
                </div>
                <div class="pet-info__pet-option">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="d-flex flex-row">
                            <button class="pet-selection" type="button" data-speciesId="1" data-selected="false"> 
                                <img class="off-hover-icon" src="../../../images-2/dog-dark.svg" alt="Dog Icon">
                                <img class="on-hover-icon" src="../../../images-2/dog-light.svg" alt="Dog Hover Icon">
                                Dog
                            </button>
                            <button class="pet-selection" type="button" data-speciesId="2" data-selected="false">
                                <img class="off-hover-icon" src="../../../images-2/cat-dark.svg" alt="Cat Icon">
                                <img class="on-hover-icon" src="../../../images-2/cat-light.svg" alt="Cat Hover Icon">
                                Cat
                            </button>
                        </div>
                        <button class="pet-info__delete-btn" type="button">Delete</button>
                    </div>
                    <div class="pet-error-text" style="display: none;">
                        <i class="fas fa-exclamation-circle error-icon"></i>
                        <span class="error-msg">Pet Type Required</span>
                    </div>
                </div>
            </div>
        `);

        $('.pet-info__list').append(addPetContainer);
        updateIdxPosition();
        $('input.pet-input').on('keyup paste', hideErrorMessages);
        $('.pet-selection').on('click', hideSelectPetErrMsg);
    }

    function updateIdxPosition() {
        let updatedPetList = $('.pet-info__list');
        $(updatedPetList).find('.pet-info__pet').each((index,petContainer) => {
            $(petContainer).find('.pet-input').attr({id: `GuestAccountPetName-${index}`, name: `Form.Pets[${index}].PetName`});
            $(petContainer).find('label').attr('for', `GuestAccountPetName-${index}`);
            $(petContainer).find('.pet-speciesid-input').attr({id: `Form_Pets_${index}__SpeciesId`, name: `Form.Pets[${index}].SpeciesId`});
            petCountIdxNum = index;
        });
    }  

    function togglePassword() {
        // toggle the type attribute
        let passwordInput = $(this).closest('.form-label-group').find('.account-password-input');
        const type = $(passwordInput).attr('type') === 'password' ? 'text' : 'password';
        $(passwordInput).attr('type', type);
        // toggle the eye slash icon
        $(this).toggleClass('fa-eye-slash');
    }

    function validatePassword() {
        let passwordInput = this;
        let inputType = $(passwordInput).data('type');

        if (inputType == 'general-password'){
            let generalPwValue = $(passwordInput).val();
            $(passwordInput).attr('value', generalPwValue);
            generalPwFinalValue = generalPwValue;

            // Have one number
            const oneNumRegex = /\d/;
            const hasOneNum = generalPwValue.match(oneNumRegex);
            let hasOneNumCircle = $('#PwOneNumber').siblings('.fill-circle');

            if (hasOneNum) {
                $(hasOneNumCircle).addClass('active');
                haveOneNumValid = true;
            } else {
                $(hasOneNumCircle).removeClass('active'); 
                haveOneNumValid = false;
            }

            //Have one uppercase character
            const oneUppercaseChar = /[A-Z]/;
            const hasOneUppercaseChar = generalPwValue.match(oneUppercaseChar);
            let hasOneUppercaseCircle = $('#PwOneUppercaseChar').siblings('.fill-circle');

            if (hasOneUppercaseChar) {
                $(hasOneUppercaseCircle).addClass('active');
                haveOneUppercaseValid = true;
            } else {
                $(hasOneUppercaseCircle).removeClass('active');
                haveOneUppercaseValid = false;
            }

            //Have one lowercase character
            const oneLowercaseChar = /[a-z]/;
            const hasOneLowercaseChar = generalPwValue.match(oneLowercaseChar);
            let hasOneLowercaseCircle = $('#PwOneLowercaseChar').siblings('.fill-circle');

            if (hasOneLowercaseChar) {
                $(hasOneLowercaseCircle).addClass('active');
                haveOneLowercaseValid = true;
            } else {
                $(hasOneLowercaseCircle).removeClass('active');
                haveOneLowercaseValid = false;
            }

            //Have one special chracter
            const oneSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            const hasOneSpecialChar = generalPwValue.match(oneSpecialChar);
            let hasOneSpecialCircle = $('#PwOneSpecialChar').siblings('.fill-circle');

            if (hasOneSpecialChar) {
                $(hasOneSpecialCircle).addClass('active');
                haveOneSpecialCharValid = true;
            } else {
                $(hasOneSpecialCircle).removeClass('active');
                haveOneSpecialCharValid = false;
            }

            //Have 8 characters min
            const min8Char = /^(?=.*\d).{8,}$/;
            const hasMin8Char = generalPwValue.match(min8Char);
            let hasMin8CharCircle = $('#PwMin8Char').siblings('.fill-circle');

            if (hasMin8Char) {
                $(hasMin8CharCircle).addClass('active');
                have8MinCharValid = true;
            } else {
                $(hasMin8CharCircle).removeClass('active');
                have8MinCharValid = false;
            }

            //Use case to see if passwords match
            let pwMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(pwMatchCircle).addClass('active');

                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Step4ContinueBtn.removeAttr('disabled');
                }
            } else {
                $(pwMatchCircle).removeClass('active');
                ui.$Step4ContinueBtn.attr('disabled', 'disabled');
            }
        } 

        if (inputType == 'confirm-password'){

            let confirmPwValue = $(passwordInput).val();
            let passwordsMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            $(passwordInput).attr('value', confirmPwValue);
            confirmPwFinalValue = confirmPwValue;

            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(passwordsMatchCircle).addClass('active');
                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Step4ContinueBtn.removeAttr('disabled');
                }
            } else {
                $(passwordsMatchCircle).removeClass('active');
                ui.$Step4ContinueBtn.attr('disabled', 'disabled');
            }
        }
        
    }

    function showLoader() {
        let btnDisabledStatus = ui.$Step4ContinueBtn.is(':disabled');

        if (!btnDisabledStatus) {
            ui.$Loader.show();
        }
    }

    function showTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').show(); 
    }

    function hideTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').hide(); 
    }

    function hideStep4ErrMsg() {
        ui.$Step4GuestAcctErrMsg.hide();
    }

    function backBtnClick() {
        let backBtn = this;
        let targetValue = $(backBtn).data('target');

        ui.$sections.hide();
        updateProgressBar(targetValue);
        $('section[data-step="' + targetValue + '"').show();
    }

    function updateProgressBar(targetValue) {
        let progressValue = $('section[data-step="' + targetValue + '"').data('progress');
        $('.progress-bar').css('width', progressValue+'%').attr('aria-valuenow', progressValue);
    }

    function sendDataLayer() {
        window.VCA.AccountDatalayer.dataLayerCreateGuestAcctSuccess();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.GuestAccountSetUp.init();
});
